import { Fragment } from 'react';
import { Menu, Popover, Transition } from '@headlessui/react';
import { SearchIcon } from '@heroicons/react/solid';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { Input } from '../Form';
import Button from '../Button';
import { Link } from 'react-router-dom';
import Permission from '../Permission/Permission';
import { useAppDispatch } from '@/store';
import { signoutUser } from '@/store/slices/userSlice';

const user = {
  name: 'Chelsea Hagon',
  email: 'chelsea.hagon@example.com',
  imageUrl:
    'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
};
const navigation = [
  { name: 'Dashboard', href: '#', current: true },
  { name: 'Calendar', href: '#', current: false },
  { name: 'Teams', href: '#', current: false },
  { name: 'Directory', href: '#', current: false },
];
const userNavigation = [
  { name: 'Your Profile', href: '#' },
  { name: 'Settings', href: '#' },
  { name: 'Sign out', href: '#' },
];

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const LoggedOutButtons = () => {
  return (
    <>
      <Link to="/signin">
        <Button className="ml-8" bg="secondary">
          Login
        </Button>
      </Link>
      <Link to="/register">
        <Button className="ml-2">Signup</Button>
      </Link>
    </>
  );
};
export const HomeNavbar = () => {
  const dispatch = useAppDispatch();
  return (
    <>
      {/* When the mobile menu is open, add `overflow-hidden` to the `body` element to prevent double scrollbars */}
      <Popover
        as="header"
        className={({ open }) =>
          classNames(
            open ? 'fixed inset-0 z-40 overflow-y-auto' : '',
            'bg-white shadow lg:static lg:overflow-y-visible'
          )
        }
      >
        {({ open }) => (
          <>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="relative flex justify-between xl:grid xl:grid-cols-12 lg:gap-8">
                <div className="flex md:absolute md:left-0 md:inset-y-0 lg:static xl:col-span-2">
                  <div className="flex-shrink-0 flex items-center">
                    <a href="#">
                      <img
                        className="block h-8 w-auto"
                        src="https://tailwindui.com/img/logos/workflow-mark.svg?color=indigo&shade=600"
                        alt="Workflow"
                      />
                    </a>
                  </div>
                </div>
                <div className="min-w-0 flex-1 md:px-8 lg:px-0 xl:col-span-6">
                  <div className="flex items-center px-6 py-4 md:max-w-3xl md:mx-auto lg:max-w-none lg:mx-0 xl:px-0">
                    <Input
                      type="text"
                      name="search"
                      placeholder="Search"
                      className="block w-full"
                      icon={
                        <SearchIcon
                          className="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      }
                    />
                  </div>
                </div>
                <div className="flex items-center md:absolute md:right-0 md:inset-y-0 lg:hidden">
                  {/* Mobile menu button */}
                  <Popover.Button className="-mx-2 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Open menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Popover.Button>
                </div>
                <div className="hidden lg:flex lg:items-center lg:justify-end xl:col-span-4">
                  {/* Profile dropdown */}
                  <Permission
                    roles={['logged-out']}
                    noAccess={({ user, hasAccess }) => {
                      if (user && user.id)
                        return (
                          <Menu
                            as="div"
                            className="flex-shrink-0 relative ml-5"
                          >
                            <div>
                              <Menu.Button className="bg-white rounded-full flex focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span className="sr-only">Open user menu</span>
                                <div className="h-10 w-10 rounded-full text-white flex items-center justify-center font-bold capitalize text-xl  bg-gray-400">
                                  {user?.name?.[0]}
                                </div>
                              </Menu.Button>
                            </div>
                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-95"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-95"
                            >
                              <Menu.Items className="origin-top-right absolute z-10 right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none">
                                <Menu.Item key="Your Profile">
                                  {({ active }) => (
                                    <Link
                                      to={`profile/${user?.id}`}
                                      className={classNames(
                                        active ? 'bg-gray-100' : '',
                                        'block py-2 px-4 text-sm text-gray-700'
                                      )}
                                    >
                                      Your Profile
                                    </Link>
                                  )}
                                </Menu.Item>
                                <Menu.Item key="sign out">
                                  <a
                                    onClick={() => {
                                      dispatch(signoutUser());
                                    }}
                                    className="block cursor-pointer py-2 px-4 text-sm text-gray-700"
                                  >
                                    Sign out
                                  </a>
                                </Menu.Item>
                              </Menu.Items>
                            </Transition>
                          </Menu>
                        );
                      return <LoggedOutButtons />;
                    }}
                  >
                    <LoggedOutButtons />
                  </Permission>
                </div>
              </div>
            </div>

            <Popover.Panel as="nav" className="lg:hidden" aria-label="Global">
              <Permission
                roles={['logged-out']}
                noAccess={({ user }) => {
                  if (user && user.id)
                    return (
                      <>
                        <div className="max-w-3xl mx-auto px-2 pt-2 pb-3 space-y-1 sm:px-4">
                          {navigation.map((item) => (
                            <a
                              key={item.name}
                              href={item.href}
                              aria-current={item.current ? 'page' : undefined}
                              className={classNames(
                                item.current
                                  ? 'bg-gray-100 text-gray-900'
                                  : 'hover:bg-gray-50',
                                'block rounded-md py-2 px-3 text-base font-medium'
                              )}
                            >
                              {item.name}
                            </a>
                          ))}
                        </div>
                        <div className="border-t border-gray-200 pt-4 pb-3">
                          <div className="max-w-3xl mx-auto px-4 flex items-center sm:px-6">
                            <div className="flex-shrink-0">
                              <div className="h-10 w-10 rounded-full text-white flex items-center justify-center font-bold capitalize text-xl  bg-gray-400">
                                {user?.name?.[0]}
                              </div>
                            </div>
                            <div className="ml-3">
                              <div className="text-base font-medium text-gray-800">
                                {user.name}
                              </div>
                              <div className="text-sm font-medium text-gray-500">
                                {user.email}
                              </div>
                            </div>
                          </div>
                          <div className="mt-3 max-w-3xl mx-auto px-2 space-y-1 sm:px-4">
                            <Link
                              to={`profile/${user?.id}`}
                              className="block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                            >
                              Your Profile
                            </Link>
                            <a
                              onClick={() => {
                                dispatch(signoutUser());
                              }}
                              className="block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                            >
                              Sign out
                            </a>
                          </div>
                        </div>
                      </>
                    );
                  return <LoggedOutButtons />;
                }}
              >
                <LoggedOutButtons />
              </Permission>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </>
  );
};
